import { render, staticRenderFns } from "./BaseReportManager.vue?vue&type=template&id=76a049cf&scoped=true"
import script from "./BaseReportManager.vue?vue&type=script&lang=js"
export * from "./BaseReportManager.vue?vue&type=script&lang=js"
import style0 from "./BaseReportManager.vue?vue&type=style&index=0&id=76a049cf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a049cf",
  null
  
)

export default component.exports